import config from "config";
import { ContentLayoutType2 } from "pages/Product/ContentLayouts/ContentLayoutType2";
import {
  AssetArea,
  DescriptionArea,
  DescriptionContent,
  Image,
  SectionSubTitle,
  SectionTitle,
  TitleArea,
} from "pages/Product/ContentLayouts/styled";
import { FeatureSectionWrapper } from "pages/Product/FeaturesSection/styled";
import React from "react";
import styled from "styled-components/macro";
import { mediaMin } from "styles/media";

const StyledContentLayoutType2 = styled(ContentLayoutType2)`
  ${mediaMin.sm`
    grid-template-rows: 1fr 1fr;
    ${TitleArea} {
      justify-content: end;
      padding-bottom: 24px;
    }
  `}

  ${mediaMin.md`
    ${TitleArea} {
      justify-content: end;
      padding-bottom: 36px;
    }
  `};
`;

export function Notification() {
  return (
    <FeatureSectionWrapper id="notification">
      <StyledContentLayoutType2>
        <TitleArea>
          <SectionSubTitle>How can I manage</SectionSubTitle>
          <SectionTitle>Notification?</SectionTitle>
        </TitleArea>
        <DescriptionArea>
          <DescriptionContent>
            Everyone in a project can easily catch up on the context. The
            automated email notification and smart reminder support asynchronous
            collaboration best.
          </DescriptionContent>
        </DescriptionArea>
        <AssetArea>
          <Image
            src={`${config.RESOURCE_ORIGIN}/images/landing/product/feature-notification.png`}
          />
        </AssetArea>
      </StyledContentLayoutType2>
    </FeatureSectionWrapper>
  );
}
